import React from 'react';
import { CandidateState, Routes } from '../../_generatedTypes.g';
import { getTranslator, LanguageCode } from '../../Translator';

export const getAvatarUrl =
    (candidate: CandidateState) => Routes.Candidates.Avatar(candidate.PartyId, candidate.Position) + `?v=${encodeURIComponent(
        candidate.RowVersion)}`;

export const CandidateProfile = (props: { candidate: CandidateState, lang: LanguageCode }) => {
    const
        t = getTranslator(props.lang),
        candidate = props.candidate,
        slogan = t.translate({ NL: candidate.Slogan_NL, EN: candidate.Slogan_EN }),
        electionText = t.translate({ NL: candidate.ElectionText_NL, EN: candidate.ElectionText_EN }),
        electableText = t.translate({ NL: candidate.ElectableInOther_NL, EN: candidate.ElectableInOther_EN });

    return <div className="candidate__table">
        {candidate.HasAvatar ? [
            <label className="candidate__info__caption" />,
            <div className="candidate__info__value">
                <img alt={candidate.Name} src={getAvatarUrl(candidate)} />
            </div>
        ] : ''}
        {((slogan || '').length) ? [
            <label className="candidate__info__caption">{t['Slogan']}</label>,
            <div className="candidate__info__value">{slogan}</div>
        ] : ''}
        <label className="candidate__info__caption">{t['Election text']}</label>
        <div className="candidate__info__value">{electionText}</div>
        {((electableText || '').length) ? [
            <label className="candidate__info__caption">{t['Also electable in']}</label>,
            <div className="candidate__info__value">{electableText}</div>
        ] : ''}

        <div style={{ clear: 'both' }}></div>
    </div>
}
